import contractors from "./contractors.component";
import contractorsUrls from "./contractors.urls";
import ContractorsTransforms from "./contractors.transforms";

const contractorsModule = angular
  .module("app.components.contractors", [])
  .component("contractorsPage", contractors)
  .service("ContractorsTransforms", ContractorsTransforms)
  .config(contractorsUrls);

export default contractorsModule;



// WEBPACK FOOTER //
// ./src/pages/contractors/contractors.module.js